// extracted by mini-css-extract-plugin
export default {"info":"style_info__XXH7K","eventTitle":"style_eventTitle__jaXlP","speakerContainer":"style_speakerContainer__0prhg"};